import { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from "react-router-dom";
import Popup from './Popup';

function Wheel(props) {


    const [isSpinDone, setIsSpinDone] = useState(false)
    const [spinStatus, setSpinStatus] = useState('inactive')
    const [spinning, setSpinning] = useState(false)

    const red = [32, 19, 21, 25, 34, 27, 36, 30, 23, 5, 16, 1, 14, 9, 18, 7, 12, 3];
    const info = [
        {
            number: 1,
            color: 'red',
        },
        {
            number: 2,
            color: 'black',
        },
        {
            number: 3,
            color: 'red',
        },
        {
            number: 4,
            color: 'black',
        },
        {
            number: 5,
            color: 'red',
        },
        {
            number: 6,
            color: 'black',
        },
        {
            number: 7,
            color: 'red',
        },
        {
            number: 8,
            color: 'black'
        },
        {
            number: 9,
            color: 'red'
        },
        {
            number: 10,
            color: 'black'
        },
        {
            number: 11,
            color: 'black'
        },
        {
            number: 12,
            color: 'red'
        },
        {
            number: 13,
            color: 'black'
        },
        {
            number: 14,
            color: 'red'
        },
        {
            number: 15,
            color: 'black'
        }, {
            number: 16,
            color: 'red'
        }, {
            number: 17,
            color: 'black'
        },
        {
            number: 18,
            color: 'red'
        }, {
            number: 19,
            color: 'red'
        }, {
            number: 20,
            color: 'black'
        }, {
            number: 21,
            color: 'red'
        }, {
            number: 22,
            color: 'black'
        },
        {
            number: 23,
            color: 'red'
        },
        {
            number: 24,
            color: 'black'
        }, {
            number: 25,
            color: 'red'
        }, {
            number: 26,
            color: 'black'
        },
        {
            number: 27,
            color: 'red'
        }, {
            number: 28,
            color: 'black'
        }, {
            number: 29,
            color: 'black'
        }, {
            number: 30,
            color: 'red'
        }, {
            number: 31,
            color: 'black'
        }, {
            number: 32,
            color: 'red'
        }, {
            number: 33,
            color: 'black'
        }, {
            number: 34,
            color: 'red'
        }, {
            number: 35,
            color: 'black'
        }, {
            number: 36,
            color: 'red'
        },
        {
            number: 37,
            color: 'red'
        },
        {
            number: 38,
            color: 'green',
        },
    ]

    function Generate() {

        setIsSpinDone(false)
        setSpinning(true)
        setSpinStatus('active')

        if (props.winnerValue === null) {
            var randomNumber = Math.floor(Math.random() * 36);
            props.setWinnerValue(randomNumber)
        }

        // Sincronizar con la animación CSS que dura 9 segundos
        setTimeout(() => {
            props.setWheelSpin(true)
            setIsSpinDone(true)
            setSpinStatus('ended') // Popup aparece inmediatamente cuando termina la animación
        }, 9000); // Mantener 9 segundos para coincidir con el CSS
    }

    const navigate = useNavigate();

    const Reset = () => {
        window.parent.location.reload();
    }


    const [input, setInput] = useState('')

    const [popup, setPopup] = useState(false)

    useEffect(() => {

        if (spinStatus === 'ended') {
            // Popup inmediato una vez que termine la animación
            setPopup(true)
        }

    }, [spinStatus])

    return (
        <div class="main nutmeg p-4 pt-0 lg:pt-4 lg:px-5 xl:px-10">

            {popup && (
                <Popup 
                    winnerValue={props.winnerValue}
                    numbers={props.numbers && props.numbers.length > 0 ? props.numbers : info.map((item, index) => ({
                        number: item.number === 38 ? 38 : item.number === 37 ? 37 : item.number,
                        color: item.color,
                        values: []
                    }))}
                    sideValues={props.sideValues && props.sideValues.length > 0 ? props.sideValues : [
                        { name: '1to18', value: 0 },
                        { name: '1st12', value: 0 },
                        { name: 'even', value: 0 },
                        { name: 'red', value: 0 },
                        { name: 'black', value: 0 },
                        { name: '2nd12', value: 0 },
                        { name: 'odd', value: 0 },
                        { name: '19to36', value: 0 },
                        { name: '3rd12', value: 0 },
                        { name: '2to1_first', value: 0 },
                        { name: '2to1_second', value: 0 },
                        { name: '2to1_third', value: 0 },
                        { name: 'zero', value: 0 }
                    ]}
                    visible={setPopup}
                />
            )}

            <div class="wheel-wrapper">
                <div class="flex justify-center scale-90 lg:scale-95 xl:scale-100">
                    <div class="plate transform -ml-2 md:-ml-0 rounded-full" id="plate">
                        <ul class="inner" data-spinto={(spinning === true) ? props.winnerValue : null}>
                            <li class="number"><label><input type="radio" name="pit" value="32" /><span class="pit">32</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="15" /><span class="pit">15</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="19" /><span class="pit">19</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="4" /><span class="pit">4</span></label>
                            </li>
                            <li class="number"><label><input type="radio" name="pit" value="21" /><span class="pit">21</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="2" /><span class="pit">2</span></label>
                            </li>
                            <li class="number"><label><input type="radio" name="pit" value="25" /><span class="pit">25</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="17" /><span class="pit">17</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="34" /><span class="pit">34</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="6" /><span class="pit">6</span></label>
                            </li>
                            <li class="number"><label><input type="radio" name="pit" value="27" /><span class="pit">27</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="13" /><span class="pit">13</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="36" /><span class="pit">36</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="11" /><span class="pit">11</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="30" /><span class="pit">30</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="8" /><span class="pit">8</span></label>
                            </li>
                            <li class="number"><label><input type="radio" name="pit" value="23" /><span class="pit">23</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="10" /><span class="pit">10</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="5" /><span class="pit">5</span></label>
                            </li>
                            <li class="number"><label><input type="radio" name="pit" value="24" /><span class="pit">24</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="16" /><span class="pit">16</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="33" /><span class="pit">33</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="1" /><span class="pit">1</span></label>
                            </li>
                            <li class="number"><label><input type="radio" name="pit" value="20" /><span class="pit">20</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="14" /><span class="pit">14</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="31" /><span class="pit">31</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="9" /><span class="pit">9</span></label>
                            </li>
                            <li class="number"><label><input type="radio" name="pit" value="22" /><span class="pit">22</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="18" /><span class="pit">18</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="29" /><span class="pit">29</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="7" /><span class="pit">7</span></label>
                            </li>
                            <li class="number"><label><input type="radio" name="pit" value="28" /><span class="pit">28</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="12" /><span class="pit">12</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="35" /><span class="pit">35</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="3" /><span class="pit">3</span></label>
                            </li>
                            <li class="number"><label><input type="radio" name="pit" value="26" /><span class="pit">26</span></label></li>
                            <li class="number"><label><input type="radio" name="pit" value="38" /><span class="pit">0</span></label>
                            </li>
                        </ul>
                        <div className={(isSpinDone === true) ? 'data reveal' : 'data'} onClick={e => Generate()}>
                            <div class="data-inner">
                                <div class="mask">SPIN</div>
                                <div class="result" style={{ backgroundColor: props.winnerValue !== null && props.winnerValue !== '' ? info[props.winnerValue - 1].color : '' }}>
                                    <div class="result-number">{props.winnerValue === 38 ? '0' : props.winnerValue}</div>
                                    <div class="result-color">{props.winnerValue !== null && props.winnerValue !== '' ? info[props.winnerValue - 1].color : ''}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bg-black bg-opacity-40 p-4 rounded pick-outcome mt-5 md:mt-8 lg:scale-95 xl:scale-100">
                <div class="combined-calculator__info_table__btns">

                </div>
                <div id="total">
                    <h3 class="uppercase text-white font-black text-center text-lg md:text-xl mb-4">or pick an outcome</h3>
                    <div class="grid grid-cols-2 gap-4">
                        <input class="p-4 py-3 rounded uppercase font-extrabold" max="36" type="number" id="winner" placeholder="Number" value={input} onChange={e => {
                            props.setWinnerValue(e.target.value === '00' ? 36 : e.target.value === '0' ? 38 : e.target.value > 36 ? 36 : e.target.value)
                            setInput(e.target.value == '0' ? 0 : e.target.value > 36 ? 36 : e.target.value)
                        }} />
                        <button disabled={(spinning === true || props.winnerValue < 0 || props.winnerValue === null) ? true : false} class="generate-button btn button p-4 py-3 uppercase font-extrabold rounded bg-clifford text-white" id="spin" onClick={e => Generate()}>Generate</button>

                    </div>
                    <button class="btn button w-full p-4 py-3 mt-4 uppercase font-extrabold rounded bg-clifford text-white" onClick={e => window.location.reload()}>Reset</button>
                </div>

            </div>
        </div>
    );
}

export default Wheel;